import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Layouts
import Layout from './pages/Layout';
import AdminLayout from './AdminPages/AdminLayout';
import AdminProtectedRoute from './AdminPages/AdminProtectedRoute';

// Public Pages
import Home from './pages/home/Home';
import About from './pages/about/About';
import Gallery from './pages/gallery/Gallery';
import Achievement from './pages/Achievement/Achievement';
import Contact from './pages/contact/Contact';
import Courses from './pages/Courses/Courses';
import News from './pages/News/News';
import VideoGallery from './pages/VideoGallery/VideoGallery';

// Admin Pages
import AdminSignIn from './AdminPages/AdminSignIn/AdminSignIn';
import ViewContact from './AdminPages/contact/ViewContact';
import AddSlider from './AdminPages/home/AddSlider/AddSlider';
import AddStudentAchievement from './AdminPages/Achievement/AddStudentAchievement';
import AddGallery from './AdminPages/AddGallery/AddGallery';
import AddNews from './AdminPages/News/AddNews';
import AddYtVideo from './AdminPages/YtVideos/AddYtVideos';
import AdmissionForm from './pages/AdmissionForm/AdmissionForm';
import ViewAdmission from './AdminPages/AdmissionForm/ViewAdmissionForm';
import ChangePassword from './AdminPages/ChangePassword/ChangePassword';
import PageNotFound from './pages/PageNotFound/PageNotFound';

function App() {
  return (
    <Router>
      <Routes>

        {/* ================= PUBLIC ROUTES ================= */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/achievements" element={<Achievement />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/news" element={<News />} />
          <Route path="/video-gallery" element={<VideoGallery />} />
           <Route path="/admission-form" element={<AdmissionForm />} />
           <Route path="*" element={<PageNotFound />} />
        </Route>

        {/* ================= ADMIN LOGIN ================= */}
        <Route path="/admin" element={<AdminSignIn />} />

        {/* ================= PROTECTED ADMIN ROUTES ================= */}
        <Route element={<AdminProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route path="/admin/view-contact" element={<ViewContact />} />
            <Route path="/admin/add-slider" element={<AddSlider />} />
            <Route path="/admin/add-student-achievement" element={<AddStudentAchievement />} />
            <Route path="/admin/add-gallery" element={<AddGallery />} />
            <Route path="/admin/add-news" element={<AddNews />} />
            <Route path="/admin/add-yt-video" element={<AddYtVideo />} />
            <Route path="/admin/view-admission" element={<ViewAdmission />} />
            <Route path="/admin/change-password" element={<ChangePassword />} />
          </Route>
        </Route>

      </Routes>
    </Router>
  );
}

export default App;
